export default "__VITE_ASSET__DRJ13NuW__"